import { useFavorito } from '../hooks/useFavoritos'
import { useSesion } from '../hooks/useSesion'

/**
 * Corazón para marcar/desmarcar un producto como favorito. Sin sesión,
 * el clic abre el login de Google en vez de guardar nada; hace falta un
 * segundo clic ya logueado para marcarlo, evitando encadenar sign-in +
 * escritura en una sola promesa que podría fallar a medias.
 */
function BotonFavorito({ producto, className = '' }) {
  const { usuario, iniciarSesion } = useSesion()
  const { esFavorito, guardando, alternar } = useFavorito(producto)

  function alClic(evento) {
    evento.preventDefault()
    evento.stopPropagation()
    if (!usuario) {
      iniciarSesion()
      return
    }
    alternar()
  }

  return (
    <button
      type="button"
      onClick={alClic}
      disabled={guardando}
      aria-pressed={usuario ? esFavorito : false}
      aria-label={
        esFavorito ? `Quitar ${producto.nombre} de favoritos` : `Agregar ${producto.nombre} a favoritos`
      }
      className={`area-tactil -m-2 p-2 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
    >
      <svg
        className={`size-5 transition-colors ${esFavorito ? 'fill-oro text-oro' : 'fill-transparent text-marfil'}`}
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <path
          d="M12 21s-6.7-4.35-9.33-8.2C1.02 10.4 1.6 7 4.5 5.7 6.9 4.6 9.4 5.4 12 8c2.6-2.6 5.1-3.4 7.5-2.3 2.9 1.3 3.48 4.7 1.83 7.1C18.7 16.65 12 21 12 21z"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}

export default BotonFavorito
